module.exports = __webpack_public_path__ + "img/Front Door Window.bfaab12e.png";